import * as React from 'react'
import Img from 'components/common/Img'

export default function LogoList({ title, logos }) {
	return (
		<section className="mx-auto max-w-screen-xl px-4 py-12 text-center">
			{title && <h2 className="technical mb-8 font-bold">{title}</h2>}

			<figure className="flex flex-wrap items-center justify-center gap-x-12 gap-y-4 mix-blend-multiply">
				{logos?.map((logo, key) => (
					<Img image={logo?.image?.original} alt={logo?.name} key={key} />
				))}
			</figure>
		</section>
	)
}
